import React, { useMemo } from 'react';
import { SpotInterface } from 'types';
import { getReportRentalTypeOptions, RentalTypeFilterValue } from 'utils/constants';
import MonthYearUtil, { MonthYear } from 'utils/monthYear';
import LinesIcon from 'assets/icons/lines.svg?react';
import AGSimpleSelect from 'components/AGSelect/AGSimpleSelect/AGSimpleSelect';
import DownloadReportModal from '../../DownloadReportModal/DownloadReportModal';
import styles from './Reports.module.css';

type ReportMenuProps = {
    spot: SpotInterface;
    handleRentalTypeFilterSelected: (rentalType: RentalTypeFilterValue) => void;
    handleDateFilterSelected: (monthYear?: string) => void;
    filters: {
        rentalType: RentalTypeFilterValue;
        monthYear: MonthYear['value'];
    };
    // Whether this spot shares ticket revenue with the owner; gates the "Violations" option.
    hasTicketRevenue?: boolean;
};

function ReportMenu({
    spot,
    handleRentalTypeFilterSelected,
    handleDateFilterSelected,
    filters,
    hasTicketRevenue,
}: ReportMenuProps) {
    const monthYearUtil = new MonthYearUtil();
    const rentalTypeOptions = useMemo(() => getReportRentalTypeOptions(hasTicketRevenue), [hasTicketRevenue]);
    const selectedMonthYear: { month: number; year: number } = useMemo(() => {
        const [month, year] = filters.monthYear.split(':');
        return { month: Number(month), year: Number(year) };
    }, [filters.monthYear]);

    return (
        <div className={styles.menu}>
            <div className={styles.filters}>
                <AGSimpleSelect
                    placeholder="Filter rental type"
                    selected={filters.rentalType}
                    onSelect={(s) => handleRentalTypeFilterSelected(s as RentalTypeFilterValue)}
                    options={rentalTypeOptions}
                    icon={<LinesIcon />}
                    maxHeight="420px"
                />

                <AGSimpleSelect
                    placeholder="Select month and year"
                    selected={filters.monthYear}
                    onSelect={handleDateFilterSelected}
                    options={monthYearUtil.monthYearsForSelect}
                    icon={<LinesIcon />}
                    maxHeight="420px"
                />
            </div>

            <DownloadReportModal
                spot={spot}
                rentalType={filters.rentalType}
                month={selectedMonthYear.month}
                year={selectedMonthYear.year}
                hasTicketRevenue={hasTicketRevenue}
            />
        </div>
    );
}

export default ReportMenu;
